<template>
  <l-marker v-if="location" :lat-lng="location" />
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import { LMarker } from 'vue2-leaflet'

const components = {
  LMarker,
}

@Component({
  components,
  watch: {
    location() {
      this.$typedStore.public.geometries.update()
    },
  },
})
export default class LocationMarker extends Vue {
  get location() {
    if (this.$typedStore.public.search.filterRecords) {
      const { lat, lon } = this.$typedStore.public.search.currentLocation
      return [lat, lon]
    } else {
      return false
    }
  }
}
</script>
